import {
  emptyEtaField,
  etaPatchFromTimeChoice,
  timeChoiceFromEtaField
} from '../model/eta-bridge'

/**
 * MVVM seam exposing the pure ETA-field helpers a component needs at
 * runtime. Components must not value-import `model/`; they reach these
 * through this hook (type-only `model/` imports — e.g. `EtaFieldValue` —
 * stay free). {@link etaPatchFromTimeChoice} / {@link timeChoiceFromEtaField}
 * bridge the combined estimated-time picker to the ETA field.
 */
export function useEtaField() {
  return { emptyEtaField, etaPatchFromTimeChoice, timeChoiceFromEtaField }
}
